var path = 'js/components/new-door/new-door.template.html';
var html = "<div class=modal-header> <button type=button class=close data-dismiss=modal aria-label=Close ng-click=$dismiss()><span aria-hidden=true>×</span></button> <h4 class=modal-title>Select door type</h4> </div> <div class=modal-body> <button type=button class=\"btn btn-default btn-lg btn-block\" ng-click=\"$close('single')\">Single Door</button> <button type=button class=\"btn btn-default btn-lg btn-block\" ng-click=\"$close('double')\">Double Door</button> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/new-door/new-door.template.html
// module id = 126
// module chunks = 0